module.exports = __webpack_public_path__ + "img/builder-30.55e4a516.jpg";